class System {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if (window.matchMedia('(max-width: 768px)').matches) {
        var slideCount = document.querySelectorAll('.system-swiper .swiper-slide').length;
        console.log(slideCount);
        if (slideCount > 1) {
          const swiper = new Swiper('.system-swiper', {
            speed: 500,
            loop: true,
            spaceBetween: 20,
            centeredSlides : true,
            slidesPerView:"auto",
            
            autoplay: {
              delay: 5000,
            },
          })
        }
    }

  }
}